/********************************************************************************
Filename: np-list.js
Created: 02 Feb 2021
Author: Ron Robertson
Description: Groups np-list-item components
Usage example:
    <np-list title='My Title'>
        <np-list-item label='My Label'>
            My list description goes here
        </np-list>
    </np-list>
********************************************************************************/

(function () {
    const template = document.createElement('template');

    template.innerHTML = `
        <style>
            #np-list{
                display:flex;
                flex-direction:column;
                padding:60px 20px 0px;
            }
            h3#titleDisplay {
                text-align:center;
                padding:50px 0;
                margin:0;
                font-family:var(--h3FontFamily);
                font-size:var(--h3FontSize);
                font-weight:normal;
            }
            #content{

            }
            @media screen and (min-width: 480px) {
                #np-list{
                    padding:60px 42px 0px;
                }
            }
            @media screen and (min-width: 768px) {
                #np-list{
                    padding:80px 42px 0px;
                }
                h3#titleDisplay {
                    border-bottom: 1px solid #b8b7b3;
                }
            }
            @media screen and (min-width: 960px) {
                #np-list{
                    padding:80px 56px 0px;
                }
            }
        </style>

        <div id="np-list">
            <h3 id="titleDisplay"></h3>
            <div id="content">
                <slot></slot>
            </div><!--END
        </div><!--END np-list-->
    `;

    class NpList extends HTMLElement {
        constructor() {

            /* Always call super first in constructor */
            super();

            /* Activate the Shadow DOM */
            this.attachShadow({ mode: 'open' });

            /* Attach template to DOM */
            this.shadowRoot.appendChild(template.content.cloneNode(true));

            /* Reference to DOM Elements */
            this.titleDisplay = this.shadowRoot.getElementById("titleDisplay");

        } /* END constructor */

        /* Called when added to DOM */
        connectedCallback() {
            /* Set default attribute value */
            if (!this.hasAttribute('title')) {
                this.setAttribute('title', "");
            }

        } /* END connectedCallback */

        /* Attributes to monitor for changes */
        static get observedAttributes() {
            return ["title"];
        }

        /* What to do when attributes are changed */
        attributeChangedCallback(name, oldValue, newValue) {

            /* Update title */
            if (name === 'title') {

                /* Display title in HTML */
                this.titleDisplay.innerText = newValue;
            }

        }

        /* Getting attributes */
        get title() {
            return this.getAttribute('title');
        }

        /* Settinng attributes */
        set title(newValue) {
            this.setAttribute('title', newValue);
        }

    } /* END class */

    /* Export the class */
    window.customElements.define('np-list', NpList);

})();
